import React, { useState } from "react";
import "./TracerMain.css";
import { Container } from "react-bootstrap";
import Footer from "../../Component/Footer/Footer";
import { FiArrowRight } from "react-icons/fi";
import Folder from '../../images/folder.png' 
import Configrationinput from "../../Component/input/Configrationinput";
import Configrationsidebar from "../../Component/Sidebar/Configrationsidebar";
import Configrationavbar from "../../Component/Navbar/Configrationavbar";
const Configration = () => {
  const [hoved, setHovered] = useState();
  const toggleHover = (index) => setHovered(index);
  const [hoved2, setHovered2] = useState();
  const toggleHover2 = (index) => setHovered2(index);
  const [isActive, setActive] = useState(false);
  const toggleClass = () => {
    setActive(!isActive);
  };
  return (
    <>
      <div className="App">
        <div className="side-bar ">
          <Configrationsidebar handleClick={toggleClass} isActive={isActive} />
        </div>
        <div className="main w-100">
          <Configrationavbar isActive={isActive}/>
          <Container>
            <div className="head-select">
              <div className="top-bar">
                <Configrationinput />
              </div>
              <div className="main-select">
                <div className="productSchedule-body">
                  <ul className="configration-list">
                    <li className={hoved === 1 ? "config-list-item active" : "config-list-item" } 
                     onClick={()=>toggleHover(1)}
                     
                    >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list">
                        <li   className={hoved2 === 1 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(1)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 2 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(2)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 3 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(3)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 4 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(4)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 5 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(5)}>
                        <div className="drop-list-info">
                        Sub Setting 5
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 6 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(6)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 7 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(7)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 8 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(8)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 9 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(9)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                      </ul>
                    </li>
                    <li className={hoved === 2 ? "config-list-item active" : "config-list-item" } 
                       onClick={()=>toggleHover(2)}
                    >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list">
                        <li   className={hoved2 === 10 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(10)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 11 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(11)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 12 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(12)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 13 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(13)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 14 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(14)}>
                        <div className="drop-list-info">
                        Sub Setting 5
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 15 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(15)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 16 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(16)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 17 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(17)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 18 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(18)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                      </ul>
                    </li>
                    <li className={hoved === 3 ? "config-list-item active" : "config-list-item" } 
                       onClick={()=>toggleHover(3)}>
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list">
                        <li   className={hoved2 === 19 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(19)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 20 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(20)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 21 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(21)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 22 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(22)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 23 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(23)}>
                        <div className="drop-list-info">
                        Sub Setting 5
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 24 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(24)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 25 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(25)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 26 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(26)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                       
                      </ul>
                    </li>
                    <li className={hoved === 4 ? "config-list-item active" : "config-list-item" } 
                       onClick={()=>toggleHover(4)}
                     >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list">
                        <li   className={hoved2 === 27 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(27)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 28 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(28)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 29 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(29)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 30 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(30)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 31 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(31)}>
                        <div className="drop-list-info">
                        Sub Setting 5
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 32 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(32)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        <li   className={hoved2 === 33 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(33)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                       
                      </ul>
                    </li>
                    <li className={hoved === 5 ? "config-list-item active" : "config-list-item" } 
                     onClick={()=>toggleHover(5)}
                     >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list">
                        <li   className={hoved2 === 34 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(34)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 35 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(35)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 36 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(36)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                       
                        <li   className={hoved2 === 37 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(37)}>
                        <div className="drop-list-info">
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                        </li>
                        
                      </ul>
                    </li>
                    <li className={hoved === 6 ? "config-list-item active" : "config-list-item" } 
                     onClick={()=>toggleHover(6)}
                     >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list drop-bottom">
                        <li   className={hoved2 === 38 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(38)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 39 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(39)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 40 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(40)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 41 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(41)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                      
                      </ul>
                    </li>
                    <li className={hoved === 7 ? "config-list-item active" : "config-list-item" } 
                      onClick={()=>toggleHover(7)}
                     >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list drop-bottom">
                        <li   className={hoved2 === 42 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(42)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 43 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(43)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 44 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(44)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 45 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(45)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 46 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(46)}>
                        <div className="drop-list-info">
                        Sub Setting 5
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                       
                      </ul>
                    </li>
                    <li className={hoved === 8 ? "config-list-item active" : "config-list-item" } 
                      onClick={()=>toggleHover(8)}
                     >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list drop-bottom">
                        <li   className={hoved2 === 47 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(47)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 48 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(48)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li className="config-drop-list-item ">
                        <div className="drop-list-info">
                        Sub Setting 3
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 49 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(49)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                       
                      </ul>
                    </li>
                    <li className={hoved === 9 ? "config-list-item active" : "config-list-item" } 
                    onClick={()=>toggleHover(9)}
                     >
                      <div className="list-info">
                        <div className="list-img">
                          <img src={Folder} alt="" />
                        </div>
                        Screen..... Mac . jpg
                        <FiArrowRight className="right-arr"/>
                      </div>
                      <ul className="config-drop-list drop-bottom">
                        <li   className={hoved2 === 50 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(50)}>
                        <div className="drop-list-info">
                        Sub Setting 1
                     
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 51 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(51)}>
                        <div className="drop-list-info">
                        Sub Setting 2
                     
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 52 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(52)}>
                        <div className="drop-list-info">
                        Sub Setting 3
                    
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                        <li   className={hoved2 === 53 ? "config-drop-list-item active2" : "config-drop-list-item" } 
                     onClick={()=>toggleHover2(53)}>
                        <div className="drop-list-info">
                        Sub Setting 4
                        
                      </div>
                      <FiArrowRight className="right-arr"/>
                      <ul className="config-sub-list drop-bottom">
                        <li className="config-sub-list-items">
                          <div className="config-sub-details">
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <input type="text" />
                            </div>
                            <div className="input-feild">
                              <label htmlFor="">LABEL</label>
                              <div className="input-radio d-flex align-items-center">
                               <div className="on d-flex align-items-center"> <input type="radio" /> ON</div>
                               <div className="off d-flex align-items-center"> <input type="radio" /> OFF</div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                        </li>
                       
                      
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Container>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Configration;
